import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faFileImage,
  faFileAudio,
  faFileVideo,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileAlt,
  faFileCode,
  faFileArchive,
  faFile
} from '@fortawesome/free-regular-svg-icons'

library.add(faFileImage);
library.add(faFileAudio);
library.add(faFileVideo);
library.add(faFilePdf);
library.add(faFileWord);
library.add(faFileExcel);
library.add(faFilePowerpoint);
library.add(faFileAlt);
library.add(faFileCode);
library.add(faFileArchive);
library.add(faFile);

export function getFontAwesomeIconFromMIME(mimeType) {
  // List of official MIME Types: http://www.iana.org/assignments/media-types/media-types.xhtml
  let icon_classes = {
    // Media
    image: "file-image",
    audio: "file-audio",
    video: "file-video",
    // Documents
    "application/pdf": "file-pdf",
    "application/msword": "file-word",
    "application/vnd.ms-word": "file-word",
    "application/vnd.oasis.opendocument.text": "file-word",
    "application/vnd.openxmlformatsfficedocument.wordprocessingml": "file-word",
    "application/vnd.ms-excel": "file-excel",
    "application/vnd.openxmlformatsfficedocument.spreadsheetml": "file-excel",
    "application/vnd.oasis.opendocument.spreadsheet": "file-excel",
    "application/vnd.ms-powerpoint": "file-powerpoint",
    "application/vnd.openxmlformatsfficedocument.presentationml": "file-powerpoint",
    "application/vnd.oasis.opendocument.presentation": "file-powerpoint",
    "text/plain": "file-alt",
    "text/html": "file-code",
    "application/json": "file-code",
    // Archives
    "application/gzip": "file-archive",
    "application/zip": "file-archive"
  };

  let key = Object.keys(icon_classes).find(key => {
    return ( mimeType.search(key) === 0 );
  })
  return icon_classes[ key ] || "file";
}

export function checkBrowserSupportForMIME(type) {
  if ( checkNativeSupportForMIME( type ) ) {
    return true;
  }
  // TODO: Does not return true for mp4
  return Array.prototype.reduce.call(navigator.plugins, (supported, plugin) => {
    return supported || Array.prototype.reduce.call(plugin, (supported, mime) => {
      return supported || mime.type === type;
    }, supported);
  }, false);
}

export function checkNativeSupportForMIME(mimeType) {
  // See: https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats
  let type_list = [
    'video/webm',
    'video/mp4',
    'video/mpeg',
    'video/ogg',
    'audio/webm',
    'audio/flac',
    'audio/wave',
    'audio/x-wav',
    'audio/wav',
    'audio/mpeg',
    'audio/vorbis',
    'audio/ogg',
  ]
  return type_list.includes( mimeType );
}

export function checkImageTagSupportForMIME(mimeType) {

  // Depends on browser support: https://en.wikipedia.org/wiki/Comparison_of_web_browsers#Image_format_support

  let image_list = {
    'image/jpeg': 'img',
    'image/gif': 'img',
    'image/bmp': 'img',
    'image/x-bmp': 'img',
    'image/x-icon': 'img',
    'image/svg+xml': 'img',
    'image/png': 'img',
    'image/webp': 'img',
    'image/apng': 'img',
    'image/tiff': 'img', // only chrome
    'image/x-xbitmap': 'img', // only chrome
    // 'application/pdf': 'img', // only chrome
  }

  return image_list[ mimeType ] || false;
}

/*
types {
    text/html                             html htm shtml;
    text/css                              css;
    text/xml                              xml;
    image/gif                             gif;
    image/jpeg                            jpeg jpg;
    application/x-javascript              js;
    application/atom+xml                  atom;
    application/rss+xml                   rss;

    text/mathml                           mml;
    text/plain                            txt;
    text/vnd.sun.j2me.app-descriptor      jad;
    text/vnd.wap.wml                      wml;
    text/x-component                      htc;

    image/png                             png;
    image/tiff                            tif tiff;
    image/vnd.wap.wbmp                    wbmp;
    image/x-icon                          ico;
    image/x-jng                           jng;
    image/x-ms-bmp                        bmp;
    image/svg+xml                         svg;
    image/webp                            webp;

    application/java-archive              jar war ear;
    application/mac-binhex40              hqx;
    application/msword                    doc;
    application/pdf                       pdf;
    application/postscript                ps eps ai;
    application/rtf                       rtf;
    application/vnd.ms-excel              xls;
    application/vnd.ms-powerpoint         ppt;
    application/vnd.wap.wmlc              wmlc;
    application/vnd.google-earth.kml+xml  kml;
    application/vnd.google-earth.kmz      kmz;
    application/x-7z-compressed           7z;
    application/x-cocoa                   cco;
    application/x-java-archive-diff       jardiff;
    application/x-java-jnlp-file          jnlp;
    application/x-makeself                run;
    application/x-perl                    pl pm;
    application/x-pilot                   prc pdb;
    application/x-rar-compressed          rar;
    application/x-redhat-package-manager  rpm;
    application/x-sea                     sea;
    application/x-shockwave-flash         swf;
    application/x-stuffit                 sit;
    application/x-tcl                     tcl tk;
    application/x-x509-ca-cert            der pem crt;
    application/x-xpinstall               xpi;
    application/xhtml+xml                 xhtml;
    application/zip                       zip;

    application/octet-stream              bin exe dll;
    application/octet-stream              deb;
    application/octet-stream              dmg;
    application/octet-stream              eot;
    application/octet-stream              iso img;
    application/octet-stream              msi msp msm;

    audio/midi                            mid midi kar;
    audio/mpeg                            mp3;
    audio/ogg                             ogg;
    audio/x-realaudio                     ra;

    video/3gpp                            3gpp 3gp;
    video/mpeg                            mpeg mpg;
    video/quicktime                       mov;
    video/x-flv                           flv;
    video/x-mng                           mng;
    video/x-ms-asf                        asx asf;
    video/x-ms-wmv                        wmv;
    video/x-msvideo                       avi;
    video/mp4                             m4v mp4;
}
*/
